module.exports = __webpack_public_path__ + "static/media/ic_show_purchases_hover.e781231d.svg";